(() => {
  const normalize = text => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  const specHeading = /^(technick[eay]|technikai|muszaki|specificatii|tehnicn|specifik|to podstatne)/;
  const inboxHeading = /^(obsah balen|co je v balen|co obsahuje balen|a csomag tartalma|continutul (?:pachetului|cutiei)|vsebina (?:paketa|embalaze))/;

  function panel(heading, kind) {
    const existing = heading.parentElement;
    if (existing.classList.contains('pdp-copy-panel')) return existing;
    const nextHeading = heading.nextElementSibling;
    if (!nextHeading || !['TABLE', 'UL', 'OL', 'P'].includes(nextHeading.tagName)) return null;
    const wrapper = document.createElement('section');
    wrapper.className = `pdp-copy-panel pdp-copy-panel--${kind}`;
    heading.before(wrapper);
    wrapper.append(heading);
    let node = nextHeading;
    while (node && !/^H[1-6]$/.test(node.tagName)) {
      const next = node.nextElementSibling;
      wrapper.append(node);
      node = next;
    }
    return wrapper;
  }

  function enhance(root) {
    root.querySelectorAll('.product-desc-section__body:not([data-description-formatted])').forEach(body => {
      body.dataset.descriptionFormatted = 'true';

      body.querySelectorAll('p').forEach(paragraph => {
        const bold = paragraph.querySelector('strong,b');
        if (!bold || paragraph.textContent.trim() !== bold.textContent.trim()) return;
        const label = normalize(paragraph.textContent).replace(/:$/, '').trim();
        if (label.length > 60 || !(specHeading.test(label) || inboxHeading.test(label))) return;
        const heading = document.createElement('h3');
        while (paragraph.firstChild) heading.append(paragraph.firstChild);
        paragraph.replaceWith(heading);
      });

      body.querySelectorAll('p').forEach(paragraph => {
        const lines = [];
        let line = [];
        paragraph.childNodes.forEach(node => {
          if (node.nodeName === 'BR') { lines.push(line); line = []; }
          else line.push(node);
        });
        lines.push(line);
        const filled = lines.filter(nodes => nodes.map(node => node.textContent).join('').trim());
        if (filled.length < 2 || !filled.every(nodes => /^\s*[✔✓✅]/u.test(nodes.map(node => node.textContent).join('')))) return;
        const list = document.createElement('ul');
        filled.forEach(nodes => {
          const item = document.createElement('li');
          nodes.forEach(node => item.append(node.cloneNode(true)));
          const walker = document.createTreeWalker(item, NodeFilter.SHOW_TEXT);
          let firstText = walker.nextNode();
          while (firstText && !firstText.textContent.trim()) firstText = walker.nextNode();
          if (firstText) firstText.textContent = firstText.textContent.replace(/^\s*[✔✓✅]\s*/u, '');
          list.append(item);
        });
        paragraph.replaceWith(list);
      });

      body.querySelectorAll('h2,h3,h4').forEach(heading => {
        const label = normalize(heading.textContent);
        if (inboxHeading.test(label)) panel(heading, 'inbox');
        else if (specHeading.test(label)) {
          const wrapper = panel(heading, 'specs');
          wrapper?.querySelectorAll('ul').forEach(list => {
            const items = Array.from(list.children);
            if (!items.length || !items.every(item => item.firstElementChild?.tagName === 'STRONG' && /:\s*$/.test(item.firstElementChild.textContent))) return;
            const details = document.createElement('dl');
            details.className = 'pdp-copy-specs';
            items.forEach(item => {
              const row = document.createElement('div');
              row.className = 'pdp-copy-specs__row';
              const term = document.createElement('dt');
              term.textContent = item.firstElementChild.textContent.replace(/:\s*$/, '');
              const value = document.createElement('dd');
              Array.from(item.childNodes).forEach(node => { if (node !== item.firstElementChild) value.append(node.cloneNode(true)); });
              row.append(term, value);
              details.append(row);
            });
            list.replaceWith(details);
          });
        }
      });

      body.querySelectorAll('table').forEach(table => {
        const rows = Array.from(table.rows);
        if (rows.length && rows.every(row => row.cells.length === 2 && row.cells[0].tagName === 'TH' && row.cells[1].tagName === 'TD')) {
          table.classList.add('pdp-copy-table--key-value');
          rows.forEach(row => row.cells[0].setAttribute('scope', 'row'));
        }
        if (table.parentElement.classList.contains('pdp-copy-table-wrap')) return;
        const wrapper = document.createElement('div');
        wrapper.className = 'pdp-copy-table-wrap';
        table.before(wrapper);
        wrapper.append(table);
        if (wrapper.scrollWidth > wrapper.clientWidth) {
          wrapper.tabIndex = 0;
          wrapper.setAttribute('role', 'region');
          const heading = wrapper.closest('.pdp-copy-panel')?.querySelector('h2,h3,h4');
          if (heading) wrapper.setAttribute('aria-label', heading.textContent);
        }
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhance(document));
  else enhance(document);
  document.addEventListener('shopify:section:load', event => enhance(event.target));
})();
